export const BASE_URL = 'https://randomuser.me/api/';



